goog.provide("shadow.js.shim.module$src$svg$artwork$error_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$error_svg");
shadow.js.shim.module$src$svg$artwork$error_svg = shadow.js.nativeProvides["src/svg/artwork/error.svg"] = shadow$bridge("src/svg/artwork/error.svg");
module$shadow_js_shim_module$src$svg$artwork$error_svg.default = shadow.js.shim.module$src$svg$artwork$error_svg;
